import { ChangeDetectionStrategy, Component, computed, effect, input } from '@angular/core';
import { type FormControl, type FormGroup, ReactiveFormsModule } from '@angular/forms';

import type { RespondFormWrapperConfig } from '@core/ask-hr-dynamic-forms-types';
import { FileUploadComponent } from '@core/attachments-ui';
import { formSignalValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { FormErrorDirective, FormFieldComponent } from '@core/user-interface-legacy';

import { MAX_FILE_SIZE_MB } from './consts';
import { RespondFormWrapperComponent } from '../../partials/respond-form-wrapper/respond-form-wrapper.component';

@Component({
  selector: 'input-file-respond',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RespondFormWrapperComponent,
    ReactiveFormsModule,
    FileUploadComponent,
    TranslatePipe,
    FormFieldComponent,
    FormErrorDirective,
  ],
  template: `
    <respond-form-wrapper [answerConfig]="respondConfig()">
      <rt-form-field>
        <rt-file-upload
          [rtFormError]="{
            maxFileSize:
              'tlc.dynamic_form.errors.file_size_limit_exceeded'
              | translate: { limit: MAX_FILE_SIZE_MB + 'MB', fileSize: currentFileSize() + 'MB' },
          }"
          [buttonText]="'tlc.dynamic_form.respond.add_file' | translate"
          [formControl]="respondForm().controls.value"
        />
      </rt-form-field>
    </respond-form-wrapper>
  `,
})
export class RespondFileComponent {
  public readonly MAX_FILE_SIZE_MB = MAX_FILE_SIZE_MB;
  public respondConfig = input.required<RespondFormWrapperConfig>();
  public respondForm = input.required<
    FormGroup<{
      value: FormControl<File | null>;
    }>
  >();

  protected respondFormValue = formSignalValue(this.respondForm);
  protected currentFileSize = computed(() => {
    const file = this.respondFormValue().value;
    if (!file) return 0;

    return Number((file.size / (1024 * 1024)).toFixed(2));
  });

  private watchDisabled = effect(() => {
    const { disabled = false } = this.respondConfig();
    const control = this.respondForm().controls.value;
    if (disabled && control.enabled) {
      control.disable();
    } else if (!disabled && control.disabled) {
      control.enable();
    }
  });
}
